<template>
  <div class="main-layout-diagnostico a11y-simplificada-block">
    <!-- Todo el mapa-->
    <MapaDiagnostico />
    <!--Fichas para el mapa-->
    <FichasParaMapa class="fichas" data-section="fichas" />
    <PieComponenteLibreria class="pie-en-diagnostico"/>
  </div>
</template>

<script>
import FichasParaMapa from "./FichasParaMapa.vue";
import MapaDiagnostico from "./MapaDiagnostico.vue";
import PieComponenteLibreria from '@/components/base/PieComponenteLibreria.vue';

export default {
  components: {
    FichasParaMapa,
    MapaDiagnostico,
    PieComponenteLibreria
  },
};
</script>

<style lang="scss" scoped>
$border-color: black;
.main-layout-diagnostico {
  border-radius: 8px;
  border: 1px solid $border-color;
  .fichas {
    border-top: 1px solid $border-color;
    border-radius: 0 0 8px 8px;
    overflow: hidden;
  }
}


</style>

<style lang="scss">
.pie-en-diagnostico>a{
  margin-top: 0 !important;
}
</style>